import { Converter } from '../types/converter';

export const radiationAbsorbedDoseConverter: Converter = {
  id: 'radiationAbsorbedDose',
  name: 'Radiation Absorbed Dose Converter',
  icon: 'Radio',
  categories: ['radiology'],
  units: [
    // SI unit and prefixes
    { name: 'Gray', symbol: 'Gy', factor: 1 },
    { name: 'Exagray', symbol: 'EGy', factor: 1e18 },
    { name: 'Petagray', symbol: 'PGy', factor: 1e15 },
    { name: 'Teragray', symbol: 'TGy', factor: 1e12 },
    { name: 'Gigagray', symbol: 'GGy', factor: 1e9 },
    { name: 'Megagray', symbol: 'MGy', factor: 1e6 },
    { name: 'Kilogray', symbol: 'kGy', factor: 1e3 },
    { name: 'Hectogray', symbol: 'hGy', factor: 1e2 },
    { name: 'Dekagray', symbol: 'daGy', factor: 10 },
    { name: 'Decigray', symbol: 'dGy', factor: 0.1 },
    { name: 'Centigray', symbol: 'cGy', factor: 0.01 },
    { name: 'Milligray', symbol: 'mGy', factor: 1e-3 },
    { name: 'Microgray', symbol: 'µGy', factor: 1e-6 },
    { name: 'Nanogray', symbol: 'nGy', factor: 1e-9 },
    { name: 'Picogray', symbol: 'pGy', factor: 1e-12 },
    { name: 'Femtogray', symbol: 'fGy', factor: 1e-15 },
    { name: 'Attogray', symbol: 'aGy', factor: 1e-18 },
    
    // Traditional units
    { name: 'Rad', symbol: 'rd', factor: 0.01 },
    { name: 'Millirad', symbol: 'mrd', factor: 0.00001 },
    
    // Energy per mass units
    { name: 'Joule/kilogram', symbol: 'J/kg', factor: 1 },
    { name: 'Joule/gram', symbol: 'J/g', factor: 1000 },
    { name: 'Joule/centigram', symbol: 'J/cg', factor: 10000 },
    { name: 'Joule/milligram', symbol: 'J/mg', factor: 100000 }
  ]
};
